"use client";

import { Children, type ReactNode, useMemo } from "react";

export function InfiniteCarousel({
  children,
  ariaLabel,
  speed = 40,
  className = "",
}: {
  children: ReactNode;
  ariaLabel: string;
  /** Seconds for one full loop of the original set */
  speed?: number;
  className?: string;
}) {
  const items = useMemo(() => Children.toArray(children).filter(Boolean), [children]);

  if (items.length === 0) return null;

  const renderSet = (copyIndex: number) =>
    items.map((child, itemIndex) => (
      <div
        key={`${copyIndex}-${itemIndex}`}
        className="w-[100cqi] shrink-0 sm:w-[calc((100cqi-1.5rem)/2)]"
      >
        {child}
      </div>
    ));

  return (
    <div
      className={`group/carousel relative overflow-hidden [container-type:inline-size] ${className}`}
      aria-label={ariaLabel}
      role="region"
    >
      <div
        className="flex w-max gap-6 animate-infinite-scroll group-hover/carousel:[animation-play-state:paused]"
        style={{ animationDuration: `${speed}s` }}
      >
        {renderSet(0)}
        {renderSet(1)}
      </div>
    </div>
  );
}
